import { render, staticRenderFns } from "./ProductcsText.vue?vue&type=template&id=75e4f56f&scoped=true"
import script from "./ProductcsText.vue?vue&type=script&lang=js"
export * from "./ProductcsText.vue?vue&type=script&lang=js"
import style0 from "./ProductcsText.vue?vue&type=style&index=0&id=75e4f56f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75e4f56f",
  null
  
)

export default component.exports